import { actions } from '../store';

export default props => {
  actions.logout();
  return null;
};